import { FC } from "react";
import { StatusBadge, Card } from "@components";
import { statusDelivery, statusPickup } from "@design-system";
import { HiOutlinePencil, HiCamera } from "react-icons/hi";
import { IRouteItem } from "../../types";
import { useTranslation } from "react-i18next";

interface RouteStopCardProps {
  className?: string;
  routeStop: IRouteItem;
  stopType: "Delivery" | "Pickup" | "DeliveryAndPickup";
  hasImages: boolean;
  hasSignature: boolean;
}

export const RouteStopCard: FC<RouteStopCardProps> = (props) => {
  const { t } = useTranslation("orders");
  return (
    <div className={props.className}>
      <Card
        containerClass="w-full h-full"
        type="dashed"
        bgColorClass="dark:bg-lgb-on-dark-background border-1"
        borderClass="!py-2 !px-4 min-[1170px]:!p-4 border-lgb-grey-100 dark:border-border-subtle"
        children={
          <div className="flex justify-between flex-row-reverse min-[1170px]:flex-col gap-2 dark:text-text">
            <div className="flex flex-row-reverse min-[1170px]:flex min-[1170px]:flex-row gap-4 justify-between items-center">
              {props.stopType === "DeliveryAndPickup" ? (
                <StatusBadge
                  status={t("orders:pickup_and_delivery")}
                  bgStyle="bg-warning-muted dark:bg-warning-muted text-lgb-yellow-400 dark:text-lgb-yellow-400"
                  rounded
                />
              ) : (
                <StatusBadge
                  status={
                    props.stopType === "Pickup"
                      ? t("orders:pickup")
                      : t("orders:delivery")
                  }
                  bgStyle={
                    props.stopType === "Pickup"
                      ? statusPickup
                      : props.stopType === "Delivery"
                        ? statusDelivery
                        : "bg-surface-muted text-secondary"
                  }
                  rounded
                />
              )}
              <p className="text-muted text-nowrap">
                {props.routeStop.timing?.earliest
                  ? t("common:earliest")
                  : props.routeStop.timing?.latest
                    ? t("common:latest")
                    : props.routeStop.timing?.before
                      ? t("common:before") +
                        " " +
                        props.routeStop.timing?.before
                      : props.routeStop.timing?.after
                        ? t("common:after") +
                          " " +
                          props.routeStop.timing?.after
                        : ""}
              </p>
              <div className="block min-[1170px]:hidden flex gap-2 mt-1">
                {props.hasSignature && (
                  <HiOutlinePencil size={14} className="text-lgb-yellow-400" />
                )}
                {props.hasImages && (
                  <HiCamera size={14} className="text-lgb-pink-400" />
                )}
              </div>
            </div>
            <div>
              <p className="font-bold">
                {props.routeStop.location.addressLine}
              </p>
              <p className="text-muted">
                {props.routeStop.location.displayName}
              </p>
              {/* Visible on bigger screens */}
              <div className="hidden min-[1170px]:block min-[1170px]:flex min-[1170px]:gap-2 mt-1">
                {props.hasSignature && (
                  <HiOutlinePencil size={14} className="text-lgb-yellow-400" />
                )}
                {props.hasImages && (
                  <HiCamera size={14} className="text-lgb-pink-400" />
                )}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default RouteStopCard;
